import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faUserCheck, faComments, faTools, faCalculator, faTimes } from '@fortawesome/free-solid-svg-icons';
import WOW from 'wow.js';
import "../css/aboutus.css";
import teamsimg1 from '../assets/teamsimg1.webp';
import teamsimg2 from '../assets/teamsimg2.webp';
import teamsimg3 from '../assets/teamsimg3.webp';
import teamsimg4 from '../assets/teamsimg4.webp';
import { Helmet } from 'react-helmet-async';

const AboutUs = () => {

  const scrollToFooter = () => {
    const footer = document.getElementById("footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    new WOW().init();
  }, []);

  const navigate = useNavigate();

  const descriptions = [
    "Secure your family's future with our Life Insurance plans.",
    "Comprehensive Health Insurance for unexpected medical needs.",
    "Protect your home from natural disasters and theft.",
    "Affordable Two Wheeler Insurance with quick claims.",
    "Cover your car with our all-in-one Motor Insurance.",
    "Cyber Insurance to protect your digital life and data.",
    "Secure your shop with customized Shopkeeper Insurance.",
    "Stay prepared with Personal/Accidental Insurance.",
    "Coverage for serious illnesses with Critical Insurance.",
    "Grow your wealth with Insurance linked to investments."
  ];

  const teamMembers = [
    {
      name: "Mr. Arvind Sharma",
      title: "Chief Executive Officer ( Founder )",
      education: "M.A Economics | MBA Finance & Marketing",
      image: teamsimg1,
      details: `M.A Economics | MBA Finance & Marketing
Chief Executive Officer (Founder) Mr. Arvind Sharma is the Founder & CEO at Policy Samjho IMF Pvt. Ltd., and a well-recognized name in the financial and insurance advisory industry. With over 17 years of experience, he brings a powerful blend of expertise in insurance planning, wealth management, and client-focused advisory services.
Known for his strategic thinking, sharp industry insight, and commitment to client success, Mr. Sharma has helped thousands of families secure their financial future. He holds deep knowledge of life insurance, health insurance, term plans, ULIPs, and retirement planning products, personalizing solutions aligned with every stage of a client’s financial journey.
Mr. Sharma currently manages over ₹100 crore in Assets Under Management (AUM), guiding more than 3,500 individual investors and 950+ families. He also oversees ₹50 crore worth of investments in AIFs, PMS, and debt-based products. His strength lies in integrating insurance and investment strategies to create well-rounded financial roadmaps that protect, grow, and transfer wealth across generations.With a strong foundation in economics and advanced certifications in financial and estate planning, he provides well-researched, ethical, and customized financial solutions. Over the past 13+ years, Mr. Sharma has also made it his mission to spread awareness about insurance literacy and risk protection, ensuring clients not only invest smartly but also stay protected.
His views on insurance markets, economic trends, and financial behavior have been featured in several financial newspapers and industry platforms. He has been recognized and awarded by multiple leading AMCs and insurance providers, including being a three-time MDRT awardee, which reflects his consistent performance and client trust.
At Policy Samjho, Mr. Sharma leads with the belief that "Wealth must be protected before it is multiplied," combining the power of insurance with investment to help clients build resilient and successful financial lives.`
    },
    {
      name: "Mr. Om Prakash Mishra",
      title: "Principal Officer",
      education: "Graduate | Fellowship | Ex National Insurance Company Employee",
      image: teamsimg2,
      details: `Graduate | Fellowship | Ex National Insurance Company Employee
Principal Officer
Mr. Om Prakash Mishra serves as the Principal Officer at Policy Samjho IMF Pvt. Ltd., where he oversees all regulatory, operational, and compliance functions. With decades of hands-on expertise in underwriting, internal audits, claims, and insurance governance, he ensures that all business practices align with IRDAI regulations and industry standards.
His strong foundation in insurance operations supports the firm’s commitment to delivering compliant, ethical, and client-focused advisory services. Mr. Mishra plays a key role in policy structuring, compliance management, and strengthening internal controls ensuring that the organization functions with efficiency, integrity, and complete regulatory alignment.`
    },
    {
      name: "CA Jay Kumar Nagpal",
      title: "Strategic Financial Mentor",
      education: "Chartered Accountant | LLB",
      image: teamsimg3,
      details: `Chartered Accountant | LLB
Strategic Financial Mentor Policy Samjho IMF Pvt. Ltd.
CA Jay Kumar Nagpal is a highly respected Chartered Accountant with over 20 years of experience in company audits, financial strategy, and advanced financial modeling. Renowned for his precision, insight, and integrity, he has guided more than 100 companies across sectors through audit compliance, corporate governance, and risk-managed financial planning.
His expertise spans statutory, internal, and tax audits, as well as valuation modeling, forecasting, budgeting, and due diligence. With a practical and analytical mindset, he brings clarity to financial decision-making and empowers businesses to build robust, compliant, and future-ready frameworks.
As part of the leadership at Policy Samjho IMF Pvt. Ltd., he contributes his deep financial knowledge, mentoring capabilities, and ethical vision to support the firm’s broader mission of delivering trustworthy and transparent financial solutions.
A passionate mentor and educator, CA Jay Kumar Nagpal has also trained aspiring finance professionals and entrepreneurs through corporate programs and academic coaching, further amplifying his impact across the financial ecosystem.`
    },
    {
      name: "Kaushal Mandloi",
      title: "Insurance Sales Person",
      education: "MBA Finance & Marketing",
      image: teamsimg4,
      details: `MBA Finance & Marketing
Insurance Sales Person
Mr. Kaushal Mandloi is a dynamic and result-oriented professional with over 10+ years of extensive experience in the insurance, finance, and investment advisory sector.
With a dual specialization in Finance and Marketing (MBA), he brings a rare blend of analytical thinking and creative marketing acumen. Currently serving as Insurance Sales Person at Policy Samjho IMF Pvt. Ltd., Mr. Mandloi is responsible for leading strategic marketing initiatives, team expansion, and customer outreach programs across Indore
He has played a key role in shaping the sales vision of the company and empowering a new generation of financial advisors with practical knowledge and ethical selling approaches.`
    },
  ];

  const [currentDescriptionIndex, setCurrentDescriptionIndex] = useState(0);
  const productDescriptionRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTeamMember, setSelectedTeamMember] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const el = productDescriptionRef.current;
      if (el) {
        el.classList.remove("aboutus-fade-in");
        void el.offsetWidth;
        setCurrentDescriptionIndex(prevIndex => (prevIndex + 1) % descriptions.length);
        el.classList.add("aboutus-fade-in");
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [descriptions.length]);

  const customersRef = useRef(null);
  const consultationsRef = useRef(null);
  const calculatorsRef = useRef(null);

  useEffect(() => {
    const animateNumber = (ref, target, duration = 2000) => {
      let start = 0;
      const increment = target / (duration / 10);
      const handle = setInterval(() => {
        start += increment;
        if (start > target) {
          start = target;
          clearInterval(handle);
          if (ref.current) {
            ref.current.classList.add('aboutus-pulse-glow-animation');
          }
        }
        if (ref.current) {
          ref.current.textContent = `${Math.floor(start)}+`;
        }
      }, 10);
    };

    animateNumber(customersRef, 1000);
    animateNumber(consultationsRef, 500);
    animateNumber(calculatorsRef, 10);
  }, []);

  const handleCardClick = (member) => {
    setSelectedTeamMember(member);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedTeamMember(null);
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Policy Samjho",
    "url": "https://policysamjho.com/",
    "logo": "https://policysamjho.com/assets/frontend/img/logo.png",
    "description": "Empowering Indians with clear, unbiased insurance guidance and financial literacy. Compare, understand, and make confident policy decisions - supported by experts.",
    "founder": {
      "@type": "Person",
      "name": "Mr. Arvind Sharma"
    },
    "contactPoint": [{
      "@type": "ContactPoint",
      "telephone": "+91-9584484800",
      "email": "info@policysamjho.com",
      "contactType": "customer service",
      "areaServed": "IN"
    }],
    "sameAs": [
      "https://in.pinterest.com/policysamjho/",
      "https://www.linkedin.com/company/policysamjho"
    ]
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "About PolicySamjho | Expert Insurance Advice Team India",
    "description": "Meet the team behind PolicySamjho. We offer honest, expert insurance guidance designed to make your policy decisions clear and stress-free.",
    "url": "https://policysamjho.com/about-us/"
  };

  return (
    <>
      <Helmet>
        <title>About PolicySamjho | Expert Insurance Advice Team India</title>
        <meta name="description" content="Meet the team behind PolicySamjho. We offer honest, expert insurance guidance designed to make your policy decisions clear and stress-free." />
        <meta
          name="keywords"
          content="about Policy Samjho, insurance experts India, Arvind Sharma Policy Samjho, insurance guidance team, trusted insurance advisors, how to understand your insurance policy, personalized insurance advice in India, insurance consultation near me, insurance experts for personalized advice, insurance advice India"
        />
        <link rel="canonical" href="https://policysamjho.com/about-us/" />

        <meta property="og:title" content="About PolicySamjho | Expert Insurance Advice Team India" />
        <meta property="og:description" content="Meet the team behind PolicySamjho. We offer honest, expert insurance guidance designed to make your policy decisions clear and stress-free." />
        <meta property="og:url" content="https://policysamjho.com/about-us/" />
        <meta property="og:type" content="website" />

        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>
      </Helmet>

      <div className="container-xxl py-5 wow fadeIn" data-wow-duration="1.5s">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInLeft" data-wow-duration="1.5s">
              <h6 className="section-title text-start text-uppercase" style={{ fontSize: '1.6rem' }}>About Us</h6>
              <h1 className="mb-4 aboutus-heading-animated" style={{ color: '#192437', fontSize: '2rem' }}>
                About PolicySamjho | Expert Insurance Advice Team India
              </h1>
              <p className="mb-4" style={{ color: '#000', textAlign: 'justify' }}>
                "We provide clear, transparent policies to ensure compliance, security, and ethical practices. Our goal is to make policies easy to understand and implement for individuals and organizations."
              </p>
              <div className="row g-4 pb-4">
                <div className="col-sm-6 col-md-6 wow fadeInUp" data-wow-duration="1.5s">
                  <div className="d-flex flex-column align-items-center bg-light shadow-sm rounded p-4 w-100 aboutus-flashy-card" style={{ backgroundColor: "#fff8e1" }}>
                    <FontAwesomeIcon icon={faLightbulb} style={{ fontSize: "1.5rem", color: "#F5A526", marginBottom: "12px" }} />
                    <h6 className="mb-0 text-dark">Clarity First</h6>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 wow fadeInUp" data-wow-duration="1.5s">
                  <div className="d-flex flex-column align-items-center bg-light shadow-sm rounded p-4 w-100 aboutus-flashy-card" style={{ backgroundColor: "#e1f5fe" }}>
                    <FontAwesomeIcon icon={faUserCheck} style={{ fontSize: "1.5rem", color: "#F5A526", marginBottom: "12px" }} />
                    <h6 className="mb-0 text-dark text-nowrap">Personalized Guidance</h6>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 wow fadeInUp" data-wow-duration="1.5s">
                  <div className="d-flex flex-column align-items-center bg-light shadow-sm rounded p-4 w-100 aboutus-flashy-card" style={{ backgroundColor: "#e8f5e9" }}>
                    <FontAwesomeIcon icon={faComments} style={{ fontSize: "1.5rem", color: "#F5A526", marginBottom: "12px" }} />
                    <h6 className="mb-0 text-dark text-nowrap">Expert's Consultation</h6>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 wow fadeInUp" data-wow-duration="1.5s">
                  <div className="d-flex flex-column align-items-center bg-light shadow-sm rounded p-4 w-100 aboutus-flashy-card" style={{ backgroundColor: "#fce4ec" }}>
                    <FontAwesomeIcon icon={faTools} style={{ fontSize: "1.5rem", color: "#F5A526", marginBottom: "12px" }} />
                    <h6 className="mb-0 text-dark">Smart Tools</h6>
                  </div>
                </div>
              </div>
              <button className="aboutus-button" onClick={scrollToFooter}>
                Contact Us
              </button>
            </div>

            <div className="col-lg-6 position-relative">
              <div className="row gy-4 justify-content-center">
                <div className="col-md-10">
                  <div className="p-2 shadow rounded text-center d-flex flex-column align-items-center" style={{ backgroundColor: "#e0f7fa" }}>
                    <div className="d-flex align-items-center mb-2">
                      <FontAwesomeIcon icon={faUserCheck} style={{ fontSize: "1.5rem", color: "#F5A526", marginRight: "8px" }} />
                      <h2 className="mb-0" style={{ color: "#192437", fontSize: "2.5rem" }}>
                        <span ref={customersRef}>0+</span>
                      </h2>
                    </div>
                    <h5 className="mb-2" style={{ color: "#007bff", fontSize: "1.2rem", fontWeight: "bold" }}>Satisfied Customers</h5>
                    <p className="mb-2 aboutus-slide-in-fade-animation" style={{ color: "#444", fontSize: "0.9rem", maxWidth: "320px" }}>
                      People across India trust us for clear, honest, and stress-free insurance guidance.
                    </p>
                  </div>
                </div>

                <div className="col-md-10">
                  <div className="p-2 shadow rounded text-center d-flex flex-column align-items-center" style={{ backgroundColor: "#fff8e1" }}>
                    <div className="d-flex align-items-center mb-2">
                      <FontAwesomeIcon icon={faComments} style={{ fontSize: "1.5rem", color: "#F5A526", marginRight: "8px" }} />
                      <h2 className="mb-0" style={{ color: "#192437", fontSize: "2.5rem" }}>
                        <span ref={consultationsRef}>0+</span>
                      </h2>
                    </div>
                    <h5 className="mb-2" style={{ color: "#28a745", fontSize: "1.2rem", fontWeight: "bold" }}>Consultations Booked</h5>
                    <p className="mb-2 aboutus-slide-in-fade-animation" style={{ color: "#444", fontSize: "0.9rem", maxWidth: "320px" }}>
                      People across India trust us for clear, honest, and stress-free insurance guidance.
                    </p>
                  </div>
                </div>

                <div className="col-md-10">
                  <div className="p-2 shadow rounded text-center d-flex flex-column align-items-center" style={{ backgroundColor: "#dcedc8" }}>
                    <div className="d-flex align-items-center mb-2">
                      <FontAwesomeIcon icon={faCalculator} style={{ fontSize: "1.5rem", color: "#F5A526", marginRight: "8px" }} />
                      <h2 className="mb-0" style={{ color: "#192437", fontSize: "2.5rem" }}>
                        <span ref={calculatorsRef}>0+</span>
                      </h2>
                    </div>
                    <h5 className="mb-2" style={{ color: "#dc3545", fontSize: "1.2rem", fontWeight: "bold" }}>Smart Calculators Launched</h5>
                    <p ref={productDescriptionRef} className="mb-2 aboutus-fade-in" style={{ color: "#444", fontSize: "0.9rem", maxWidth: "320px" }}>
                      {descriptions[currentDescriptionIndex]}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5 wow fadeIn" data-wow-duration="1.5s">
        <h1 className="aboutus-teams-heading">
          <span style={{ color: '#192437 ' }}>Meet Our </span>
          <span style={{ color: '#F5A526' }}> Core Team</span>
        </h1>
        <div className="row justify-content-center">
          {teamMembers.map((member, index) => (
            <div key={index} className="col-md-6 col-lg-3 mb-4">
              <div
                className="card h-100 border-0 shadow-sm aboutus-team-card-hover"
                onClick={() => handleCardClick(member)}
              >
                <img src={member.image} alt={member.name} className="card-img-top" style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  borderTopLeftRadius: '0.375rem',
                  borderTopRightRadius: '0.375rem'
                }} />
                <div className="card-body text-center">
                  <h5 className="card-title mt-2" style={{ color: '#192437', textAlign: 'center' }}><strong>{member.name}</strong></h5>
                  {member.education && <p className="card-text" style={{ color: '#6c757d', fontSize: '0.9rem' }}><strong>{member.education}</strong></p>}
                  <p className="card-text" style={{ color: '#F5A526' }}><strong>{member.title}</strong></p>
                </div>
                <div className="aboutus-hover-text">Click to view full details</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {showModal && selectedTeamMember && (
        <div className="aboutus-modal-backdrop">
          <div className="aboutus-modal-content-custom">
            <button className="aboutus-modal-close-button" onClick={closeModal}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <div className="aboutus-modal-header-custom">
              <img src={selectedTeamMember.image} alt={selectedTeamMember.name} className="aboutus-modal-img" />
              <div className="aboutus-modal-details-text">
                <h3 className="aboutus-modal-title-custom">{selectedTeamMember.name}</h3>
                {selectedTeamMember.education && <p className="aboutus-modal-subtitle-custom" style={{ color: '#6c757d', fontSize: '1rem', fontWeight: 'normal' }}>{selectedTeamMember.education}</p>}
                <p className="aboutus-modal-subtitle-custom">{selectedTeamMember.title}</p>
              </div>
            </div>
            <div className="aboutus-modal-body-custom">
              <p style={{ whiteSpace: 'pre-wrap' }}>{selectedTeamMember.details}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AboutUs;